import { matchPath } from 'react-router-dom';

function isLinkActive(location, paths) {
  if (matchPath(location.pathname, { path: paths }) !== null) return true;
  if (paths.includes(location.pathname)) return true;
  if (paths.includes(location.pathname.replace(/\/$/, ''))) return true;
  return false;
}

export default isLinkActive;
